export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7670.43242b0e.jpg";